import React from 'react';

interface WalletProps {
  isConnected: boolean;
  userAddress: string;
  onConnect: () => void;
  onDisconnect: () => void;
}

export const Wallet: React.FC<WalletProps> = ({ isConnected, userAddress, onConnect, onDisconnect }) => (
  <div className="header-right">
    {!isConnected ? (
      <button className="connect-btn" onClick={onConnect} type="button">
        <span>🦊</span> Connect Wallet
      </button>
    ) : (
      <div className="wallet-info">
        <span className="address">
          {userAddress.slice(0, 6)}...{userAddress.slice(-4)}
        </span>
        <button className="disconnect-btn" onClick={onDisconnect} type="button">
          Disconnect
        </button>
      </div>
    )}
  </div>
);
